module.exports = __webpack_public_path__ + "heyground.c5ae628e9180ae95ae3d.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/heyground.eot
// module id = 1012
// module chunks = 2